"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamingChatNotification = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const GamingChatNotification = ({ text }) => (0, jsx_runtime_1.jsx)("div", { className: 'chat-notification', children: text });
exports.GamingChatNotification = GamingChatNotification;
